import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, ButtonGroup, Col, Label, Row} from 'reactstrap';
import {AvField, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IRootState} from 'app/shared/reducers';
import {createEntity, getEntity, reset, updateEntity} from './followup.reducer';

export interface IFollowupUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const FollowupUpdate = (props: IFollowupUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const [countryId, setCountryId] = useState(null);
  const [activeStatus, setActiveStatus] = useState(true);
  const [aliveStatus, setAliveStatus] = useState(true);
  const [delivered, setDelivered] = useState(false);
  const {followupEntity, loading, updating} = props;

  const handleClose = () => {
    props.history.push('/followup');
  };

  useEffect(() => {
    if (isNew) {
      const params = new URLSearchParams(props.location.search);
      setCountryId(params.get('country_id'));
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (!isNew && followupEntity?.id) setActiveStatus(followupEntity?.isActive);
    if (!isNew && followupEntity?.id) setAliveStatus(followupEntity?.isAlive);
    if (!isNew && followupEntity?.id) setDelivered(followupEntity?.isDelivered);
  }, [followupEntity]);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const cid = isNew ? countryId : followupEntity.countryId;
      const country = props.countries.find(c => c.id === cid);
      const entity = {
        ...followupEntity,
        ...values,
        isActive: activeStatus,
        isAlive: aliveStatus,
        isDelivered: delivered,
        // country
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaApp.followup.home.createOrEditLabel">Create or edit a Followup</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : followupEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="followup-id">ID</Label>
                  <AvInput id="followup-id" type="text" className="form-control" name="id" required readOnly/>
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="activeStatusLabel" for="followup-activeStatus">
                  Active Status
                </Label>
                <ButtonGroup style={{marginLeft: '30px'}}>
                  <Button
                    color={activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={e => {
                      setActiveStatus(true);
                    }}
                  >
                    Active
                  </Button>

                  <Button
                    color={!activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={() => {
                      setActiveStatus(false);
                    }}
                  >
                    Inactive
                  </Button>
                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="isAliveLabel" for="followup-isAlive">
                  IsAlive
                </Label>
                <ButtonGroup style={{marginLeft: '30px'}}>
                  <Button
                    color={aliveStatus ? 'primary' : 'secondary'}
                    value={aliveStatus}
                    onClick={e => {
                      setAliveStatus(true);
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    color={!aliveStatus ? 'primary' : 'secondary'}
                    value={aliveStatus}
                    onClick={() => {
                      setAliveStatus(false);
                    }}
                  >
                    No
                  </Button>
                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="isDeliveredLabel" for="followup-isDelivered">
                  Is Delivered
                </Label>
                <ButtonGroup style={{marginLeft: '30px'}}>
                  <Button
                    color={delivered === true ? 'primary' : 'secondary'}
                    value={delivered}
                    onClick={e => {
                      setDelivered(true);
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    color={delivered === false ? 'primary' : 'secondary'}
                    value={delivered}
                    onClick={() => {
                      setDelivered(false);
                    }}
                  >
                    No
                  </Button>
                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="followupTypeLabel" for="followup-emergencyType">
                  Followup Type
                </Label>
                <AvInput
                  id="followup-emergencyType"
                  type="select"
                  className="form-control"
                  name="followupType"
                  value={(!isNew && followupEntity.followupType) || 'MATERNAL'}
                >
                  <option value="MATERNAL">MATERNAL</option>
                  <option value="NEONATAL">NEONATAL</option>
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label id="emergencyTypeLabel" for="emergencyType">
                  Emergency Type
                </Label>
                <AvInput
                  id="emergencyType"
                  type="select"
                  className="form-control"
                  name="emergencyType"
                  value={(!isNew && followupEntity?.emergencyType) || 'ANTEPARTUM'}
                >
                  <option value="ANTEPARTUM">ANTEPARTUM</option>
                  <option value="LABOUR">LABOUR</option>
                  <option value="POSTPARTUM">POSTPARTUM</option>
                  <option value="NEONATAL">NEONATAL</option>
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label id="enConditionLabel" for="followup-enCondition">
                  Followup (English)
                </Label>
                <AvField
                  id="followup-enCondition"
                  type="text"
                  name="enFollowup"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="stConditionLabel" for="followup-stCondition">
                  Followup (Local Language)
                </Label>
                <AvField
                  id="followup-stCondition"
                  type="text"
                  name="stFollowup"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>
              {props.countries && props.countries.length > 0 && (
                <AvGroup>
                  <Label for="followup-country">Country</Label>
                  <AvInput
                    id="followup-country"
                    type="select"
                    className="form-control"
                    name="countryId"
                    value={isNew ? countryId : followupEntity.countryId}
                  >
                    {props.countries
                      ? props.countries.map(country => (
                        <option value={country.id} key={country.id}>
                          {country.name}
                        </option>
                      ))
                      : null}
                  </AvInput>
                </AvGroup>
              )}
              <Button tag={Link} id="cancel-save" to="/followup" replace color="info">
                <FontAwesomeIcon icon="arrow-left"/>
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save"/>
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  followupEntity: storeState.followup.entity,
  loading: storeState.followup.loading,
  updating: storeState.followup.updating,
  updateSuccess: storeState.followup.updateSuccess,
  countries: storeState.authentication.countries,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(FollowupUpdate);
